import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { useTheme } from '@material-ui/core/styles';
import GroupIcon from '@mui/icons-material/Group';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import LiveTvIcon from '@mui/icons-material/LiveTv';

const metrics = [
  { value: '20,000+', label: 'Seguidores en todas sus redes sumadas', Icon: GroupIcon },
  { value: '30,000+', label: 'Visitas mensuales del ecosistema TNO (alcance editorial multiplataforma)', Icon: TrendingUpIcon },
  { value: '20+', label: 'Episodios On-Demand disponibles (biblioteca de consulta permanente)', Icon: OndemandVideoIcon },
  { value: '1', label: 'Emisión en vivo semanal con distribución global por TNO Network', Icon: LiveTvIcon },
];

const Metrics = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography sx={{ textTransform: 'uppercase', fontWeight: 'medium' }} gutterBottom color="primary" align="center">
          Números
        </Typography>
        <Box component={Typography} fontWeight={700} variant="h3" align="center" gutterBottom color="primary">
          El impacto de Dr. Condominio
        </Box>
        <Typography variant="h6" align="center" color="textSecondary" sx={{ mb: 4 }}>
          Tu marca llega a una audiencia con alto poder de decisión: miembros de juntas de condominio y gerentes que manejan presupuestos colectivos.
        </Typography>
      </Box>
      <Grid container spacing={2}>
        {metrics.map((m, i) => (
          <Grid item xs={12} sm={6} md={3} key={i}>
            <Box textAlign="center" p={2} sx={{ bgcolor: theme.palette.primary.main + '14', borderRadius: 2 }}>
              <Box display="flex" justifyContent="center" alignItems="center" marginBottom={1}>
                <m.Icon color="primary" sx={{ fontSize: 40 }} />
              </Box>
              <Typography variant="h4" color="primary">{m.value}</Typography>
              <Typography variant="body2" color="textSecondary">{m.label}</Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Metrics;
